import { useEffect, useState } from 'react';
import MaskedInput from 'react-text-mask';
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faSave, faCancel, faBedPulse } from '@fortawesome/free-solid-svg-icons';
import { Field, Form, Formik, FormikHelpers } from 'formik';
import { TextField } from '@mui/material';
import FormErrorContainer from '../shared/FormErrorContainer';
import * as Yup from "yup";
import { CircularProgress } from '@mui/material';

interface Props {
    show: boolean, 
    handleClose: () => void, 
    selectedRow: any
}
const ModalComment: React.FC<Props> = ( { show, handleClose, selectedRow } ) => {

    return (
        <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
            <Modal.Header>
                <Modal.Title>Support Call</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12">
                        <div className="cardCustom p-3">
                            <div className="row mb-2">
                                <div className="col-md-12">
                                    <span>
                                        {selectedRow && selectedRow['comment'] || 'NA'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-md revrex-outline-btn mt-3" onClick={handleClose}>
                    <span>Close</span>
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalComment;